var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-material-card',{attrs:{"icon":_vm.resource.icon,"title":_vm.title}},[_c('v-card-text',[_c(_setup.CollectionTable)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }